/**
 * Copyright 2025 Lumavec Group LLC
 *
 * All rights reserved. No part of this software may be used, copied, modified,
 * or distributed without explicit written permission. This software is provided
 * "as-is" without warranty of any kind, express or implied, including but not
 * limited to warranties of merchantability or fitness for a particular purpose.
 */

/**
 * Worktree Operations
 * 
 * Handles git worktree creation for isolated operations.
 */

import { getProductServerBaseUrl } from './base';

/**
 * Create a worktree for an operation
 * Product server endpoint - uses direct fetch
 */
export async function createWorktree(
  repositoryUrl: string, 
  operation: string, 
  baseBranch: string = 'velocity'
): Promise<{ success: boolean; worktreePath?: string; error?: string }> {
  try {
    console.log('[SkillShop Service] Creating worktree:', { repositoryUrl, operation, baseBranch });

    const response = await fetch(`${getProductServerBaseUrl()}/api/github/worktrees/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ repositoryUrl, operation, baseBranch }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `Failed to create worktree (${response.status})`);
    }

    const result = await response.json();
    console.log('[SkillShop Service] Worktree created:', result.worktreePath);
    
    return {
      success: true,
      worktreePath: result.worktreePath
    };
  } catch (error: any) {
    console.error('[SkillShop Service] Error creating worktree:', error);
    return {
      success: false,
      error: error.message || 'Failed to create worktree'
    };
  }
}

